module.exports = __webpack_public_path__ + "9fa27b49123a4ea8e642214f4331879c.jpg";